import { gql } from '@apollo/client';

export interface CounterpartRatingMatrixYearProps {
  year: number;
  ratingAPlus: number | null;
  ratingA: number | null;
  ratingB: number | null;
  ratingC: number | null;
  withoutRating: number | null;
  total: number | null;
}

export interface CounterpartRatingMatrixProps {
  yearlyValues: CounterpartRatingMatrixYearProps[];
}

export interface CounterpartRatingMatrixResponseProps {
  lastCompetence: string;
  currency: CounterpartRatingMatrixProps;
  mwm: CounterpartRatingMatrixProps;
  percent: CounterpartRatingMatrixProps;
}

export interface ResponseProps {
  creditCounterpartRatingMatrix: CounterpartRatingMatrixResponseProps;
}

const CREDIT_COUNTERPART_RATING_MATRIX = gql`
  query creditCounterpartRatingMatrix {
    creditCounterpartRatingMatrix {
      lastCompetence
      currency {
        yearlyValues {
          year
          ratingAPlus
          ratingA
          ratingB
          ratingC
          withoutRating
          total
        }
      }
      mwm {
        yearlyValues {
          year
          ratingAPlus
          ratingA
          ratingB
          ratingC
          withoutRating
          total
        }
      }
      percent {
        yearlyValues {
          year
          ratingAPlus
          ratingA
          ratingB
          ratingC
          withoutRating
          total
        }
      }
    }
  }
`;

export default CREDIT_COUNTERPART_RATING_MATRIX;
